import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CORE_CONFIG_TOKEN } from '@ndk/ng-core/component/core.config';
import { NDDTranslationService } from '@ndk/ng-translation';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ICoreConfigInternal } from '@core/core.config.model';
import { LoggerService } from '@core/logger/logger.service';
import { QuotaBehaviorTypes } from '@features/quota/shared/quota-behavior-types.enum';

@Injectable()
export class SettingsQuotasActivationBehaviorService {
    private apiUrl: string;

    constructor(
        @Inject(CORE_CONFIG_TOKEN) config: ICoreConfigInternal,
        private http: HttpClient,
        private loggerService: LoggerService,
        private translation: NDDTranslationService,
    ) {
        this.apiUrl = `${ config.apiEndpoint }api/settings-quotas`;
    }

    public getBehavior(): Observable<QuotaBehaviorTypes> {
        return this.http.get<QuotaBehaviorTypes>(`${ this.apiUrl }/behavior`);
    }

    public updateBehavior(value: QuotaBehaviorTypes): Observable<boolean> {
        const command: any = { quotaBehaviorTypes: value };

        return this.http.post<boolean>(`${ this.apiUrl }/behavior`, command)
            .pipe(tap(() => this.loggerService.success(true, [this.translation.instant('360SettingsSuccess')])));
    }
}
